import { useDonationFormContext } from '../../DonationFormProvider'
import PageCheckBox from './PageCheckBox'
import { useShallow } from 'zustand/react/shallow'
import { useEffect } from 'react'
import { formatDonorPaysWording } from '../../donorPaysWording'
import { usePurchaseCopy } from '../../purchaseCopy'

type DonorPaysCheckboxProps = {
  donorPaysAmount: number
}

const DonorPaysCheckbox = ({ donorPaysAmount }: DonorPaysCheckboxProps) => {
  const { formValues, setFormValues } = useDonationFormContext(
    useShallow(({ formValues, actions }) => ({
      formValues,
      setFormValues: actions.setFormValues,
    })),
  )
  const purchaseCopy = usePurchaseCopy()
  const { isDonorPays } = formValues

  useEffect(() => {
    setFormValues({ isDonorPays: true })
  }, [])

  return (
    <PageCheckBox
      id="donor-pays"
      label={purchaseCopy(formatDonorPaysWording(undefined, donorPaysAmount))}
      isChecked={isDonorPays ?? true}
      onChange={(value) => setFormValues({ ...formValues, isDonorPays: value })}
    />
  )
}

export default DonorPaysCheckbox
